import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './hooks/useAuth'
import Landing from './pages/Landing'
import Login from './pages/Login'
import Signup from './pages/Signup'
import Admin from './pages/Admin'
import LecturerPortal from './pages/LecturerPortal'
import AttendPortal from './pages/AttendPortal'
import AcceptInvite from './pages/AcceptInvite'
import SuperAdmin from './pages/SuperAdmin'
import AuthCallback from './pages/AuthCallback'
import './styles/global.css'

function ProtectedRoute({ children, role }) {
  const { user, profile, loading } = useAuth()

  if (loading) return (
    <div className="page-center">
      <span className="spinner" style={{ width: 32, height: 32, borderWidth: 3 }} />
    </div>
  )

  if (!user) return <Navigate to="/login" replace />

  // Profile still loading after auth (e.g. Google OAuth trigger delay) — wait
  if (role && !profile) return (
    <div className="page-center">
      <span className="spinner" style={{ width: 32, height: 32, borderWidth: 3 }} />
    </div>
  )

  if (role && profile?.role !== role) return <Navigate to="/login" replace />

  return children
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public */}
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/invite/:token" element={<AcceptInvite />} />

          {/* ── Google OAuth lands here — was MISSING, causing silent Google login failure ── */}
          <Route path="/auth/callback" element={<AuthCallback />} />

          {/* Student attendance portal */}
          <Route path="/attend" element={<AttendPortal />} />
          <Route path="/attend/:slug" element={<AttendPortal />} />

          {/* Admin portal */}
          <Route path="/admin" element={<ProtectedRoute role="org_admin"><Admin /></ProtectedRoute>} />

          {/* Lecturer portal */}
          <Route path="/lecturer" element={<ProtectedRoute role="lecturer"><LecturerPortal /></ProtectedRoute>} />

          {/* Super admin */}
          <Route path="/superadmin" element={<ProtectedRoute role="superadmin"><SuperAdmin /></ProtectedRoute>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}
